import {gregorianDate} from "@/utils/gregorianDate.js";
export function discordRegistrationTime(discordID, format = 'DD MMM YYYY - HH:mm') {
  if (!discordID) return null;
  const TIMESTAMP_OFFSET = 22n;
  const DISCORD_EPOCH = 1420070400000n;
  const id = BigInt(discordID);
  const timestamp = (id >> TIMESTAMP_OFFSET) + DISCORD_EPOCH;
  return gregorianDate(Number(timestamp), format);
}